import React from 'react'
import {Link } from "react-router-dom";

function PageNotFound() {


    return(
        <section className="knsl-banner-simple knsl-transition-bottom">
            <img src="assets/img/palm.svg" className="knsl-deco-left" alt="palm" />
            <img src="assets/img/palm.svg" className="knsl-deco-right" alt="palm" />
            <div className="container">
                <div className="row">
                <div className="col-lg-12">

                    <div className="knsl-center knsl-title-frame">
                        <h1 className="knsl-h1-inner">Oops! Where are we?</h1>
                        <div className="knsl-404">404</div>
                        <p className="knsl-mb-30">Page not Found! The page you are looking for was moved, removed,<br/> renamed or might never existed.</p>
                        <Link to="/" className="knsl-btn">Back to Home</Link>
                    </div>

                </div>
                </div>
            </div>
        </section>
    )
}

export default PageNotFound as React.FC